import axios from 'axios'
import { DECRYPTING_ID } from '../../../config/realstar-api-config';


export const decryptingUserID = async (userEncryptedID) => {
    try {
        const url = `${DECRYPTING_ID}${userEncryptedID}`; 

        const response = await axios.get(url);
        return response.data
    } catch (error) {
      console.error('Error decrypting id:', error);
      throw error;
    }
  }